/**
 * @deprecated Please import this function from `@hotjar/insights-common/lib/plural`.
 */
export const plural = ({ one, other }, x) => (x === 1 ? one : other);
